import React from 'react';
import { Link } from 'react-router-dom';
import { LogIn, LogOut, User, UserPlus } from 'lucide-react';
import { useAuth } from '../../context/AuthContext';
import { getDisplayName } from '../../services/authStorage';

export function ConnectWalletButton({ variant = 'header', onNavigate }) {
  const { user, isAuthenticated, disconnect } = useAuth();

  const handleDisconnect = () => {
    disconnect();
    onNavigate?.();
  };

  if (isAuthenticated && user) {
    if (variant === 'drawer') {
      return (
        <div className="space-y-3">
          <div className="flex items-center gap-2 rounded-lg border border-brand-gold bg-brand-gold-light/30 px-4 py-3 text-sm font-semibold text-brand-red">
            <User className="h-4 w-4 shrink-0" />
            <span className="truncate">{getDisplayName(user)}</span>
          </div>
          <button
            type="button"
            onClick={handleDisconnect}
            className="flex w-full items-center justify-center gap-2 rounded-lg border border-gray-200 px-4 py-2.5 text-sm font-semibold text-gray-600 transition-colors hover:border-brand-red hover:text-brand-red"
          >
            <LogOut className="h-4 w-4" />
            ออกจากระบบ
          </button>
        </div>
      );
    }

    return (
      <div className="flex items-center gap-2">
        <div className="hidden items-center gap-2 rounded-lg border border-brand-gold bg-brand-gold-light/30 px-3 py-2 text-sm font-semibold text-brand-red sm:flex">
          <User className="h-4 w-4" />
          {getDisplayName(user)}
        </div>
        <button
          type="button"
          onClick={disconnect}
          title="ออกจากระบบ"
          className="flex items-center gap-2 rounded-lg border border-gray-200 px-3 py-2 text-sm font-semibold text-gray-600 transition-colors hover:border-brand-red hover:text-brand-red"
        >
          <LogOut className="h-4 w-4" />
          <span className="hidden sm:inline">ออกจากระบบ</span>
        </button>
      </div>
    );
  }

  if (variant === 'panel' || variant === 'drawer') {
    return (
      <div className="space-y-3">
        <Link
          to="/register"
          onClick={onNavigate}
          className="flex w-full items-center justify-center gap-2 rounded-lg border-2 border-brand-gold bg-brand-gold-light/30 px-4 py-2.5 text-sm font-semibold text-brand-red transition-colors hover:bg-brand-gold-light"
        >
          <UserPlus className="h-4 w-4" />
          สมัครสมาชิก
        </Link>

        <Link
          to="/login"
          onClick={onNavigate}
          className="flex w-full items-center justify-center gap-2 rounded-lg bg-brand-red px-4 py-2.5 text-sm font-semibold text-white transition-colors hover:bg-red-700"
        >
          <LogIn className="h-4 w-4" />
          เข้าสู่ระบบ
        </Link>
      </div>
    );
  }

  return (
    <div className="flex items-center gap-2">
      <Link
        to="/register"
        className="flex items-center gap-2 rounded-lg border-2 border-brand-gold bg-brand-gold-light/30 px-3 py-2 text-sm font-semibold text-brand-red transition-colors hover:bg-brand-gold-light sm:px-4"
      >
        <UserPlus className="h-4 w-4" />
        <span className="hidden sm:inline">สมัครสมาชิก</span>
        <span className="sm:hidden">สมัคร</span>
      </Link>

      <Link
        to="/login"
        className="flex items-center gap-2 rounded-lg bg-brand-red px-3 py-2 text-sm font-semibold text-white transition-colors hover:bg-red-700 sm:px-4"
      >
        <LogIn className="h-4 w-4" />
        <span>Login</span>
      </Link>
    </div>
  );
}
